import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { Label } from "../ui/label";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { useToast } from "../../hooks/use-toast";

export function ThemeSettings() {
  const { theme, setTheme } = useTheme();
  const { toast } = useToast();

  const handleThemeChange = (value: "light" | "dark" | "system") => {
    setTheme(value);
    toast({
      title: "Theme updated",
      description: `Theme has been changed to ${value} mode`,
    });
  };

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold mb-4">Theme Settings</h3>
        <p className="text-muted-foreground">
          Choose how you want the application to look
        </p>
      </div>

      <RadioGroup
        value={theme}
        onValueChange={handleThemeChange}
        className="grid gap-4"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="light" id="light" />
          <Label htmlFor="light">Light</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="dark" id="dark" />
          <Label htmlFor="dark">Dark</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="system" id="system" />
          <Label htmlFor="system">System</Label>
        </div>
      </RadioGroup>
    </div>
  );
}